'use client'

import { Button, toast } from '@payloadcms/ui'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

export function InstagramSyncButton() {
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  const handleSync = async () => {
    setLoading(true)
    try {
      const res = await fetch('/api/instagram-posts/sync', {
        method: 'POST',
        credentials: 'include',
      })
      const body = await res.json()

      if (!res.ok) {
        toast.error(body?.error || 'Instagram Posts Sync fehlgeschlagen.')
        return
      }

      toast.success(
        `Sync abgeschlossen: ${body.created} neu, ${body.updated} aktualisiert.`,
      )
      router.refresh()
    } catch {
      toast.error('Instagram Posts Sync fehlgeschlagen.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ marginBottom: 'var(--base)' }}>
      <Button onClick={handleSync} disabled={loading} buttonStyle="secondary">
        {loading ? 'Synchronisiere…' : 'Sync jetzt'}
      </Button>
    </div>
  )
}
